import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'itemlist' })
export class ItemListPipe implements PipeTransform {
    transform(value:any[],searchText:string ){

       if(!searchText){
    //     console.log('no search')
         return value  
       }

       return value.filter(it=>{   
         
           const itemname = it.itemname.toLowerCase().includes(searchText.toLowerCase())
		    const itemcategoryname = it.itemcategoryname.toLowerCase().includes(searchText.toLowerCase())
			
          
           return (itemname + itemcategoryname );      
       }) 
    }
}